import { Table } from "@similarweb/pro-logic-components";

import type { IDurationObject } from "app/services/DurationService";

import { getTrafficByCountryTableColumns } from "./trafficByCountryTableColumns";
import type { TrafficByCountryVariant, TableData } from "./types";

interface TrafficByCountryTableProps {
    isLoading: boolean;
    variant: TrafficByCountryVariant;
    duration: IDurationObject<string>;
    isYearOverYear: boolean;
    data: TableData[] | undefined;
}

export const TrafficByCountryTable = ({
    isLoading,
    variant,
    duration,
    isYearOverYear,
    data = [],
}: TrafficByCountryTableProps) => {
    const columns = getTrafficByCountryTableColumns(variant, duration, isYearOverYear);

    return (
        <Table
            isLoading={isLoading}
            sticky={false}
            withArrowButtons={false}
            theme="white"
            bordersConfig={{ header: false }}
            columnConfig={columns}
            pagination={{ pageSize: 5 }}
            scroll={{ x: "max-content" }}
            data={data}
        />
    );
};
